import { ApiFailure } from "../../api";

export type SseEvent = { event: string; data: string };

/** Separa os eventos de um texto SSE já recebido; devolve os completos e o resto (evento ainda chegando). */
export function splitSse(buffer: string): { events: SseEvent[]; rest: string } {
  const parts = buffer.replace(/\r\n/g, "\n").split("\n\n");
  const rest = parts.pop() ?? "";
  const events = parts
    .filter((p) => p.trim())
    .map((block) => {
      let event = "message";
      const data: string[] = [];
      for (const line of block.split("\n")) {
        if (line.startsWith("event:")) event = line.slice(6).trim();
        else if (line.startsWith("data:")) data.push(line.slice(5).replace(/^ /, ""));
      }
      return { event, data: data.join("\n") };
    });
  return { events, rest };
}

/**
 * POST que responde em SSE (Copiloto): erro HTTP antes do stream vira ApiFailure (mesma mensagem da API); cada evento
 * chega em `onEvent` na ordem.
 */
export async function postSse(
  path: string,
  body: unknown,
  opts: { companyId: string; signal?: AbortSignal; onEvent(e: SseEvent): void },
): Promise<void> {
  const res = await fetch(`/api/v1${path}`, {
    method: "POST",
    credentials: "same-origin",
    headers: {
      "content-type": "application/json",
      "x-company-id": opts.companyId,
      accept: "text/event-stream",
    },
    body: JSON.stringify(body),
    signal: opts.signal,
  });
  if (!res.ok || !res.body) {
    const err = (await res.json().catch(() => null)) as {
      error?: { code?: string; message?: string };
    } | null;
    if (res.status === 401) window.dispatchEvent(new CustomEvent("cx:unauthenticated"));
    throw new ApiFailure(
      res.status,
      err?.error?.code ?? "http_error",
      err?.error?.message ?? "Não foi possível concluir. Tente de novo.",
    );
  }
  const reader = res.body.pipeThrough(new TextDecoderStream()).getReader();
  let buffer = "";
  for (;;) {
    const { value, done } = await reader.read();
    if (value) buffer += value;
    const r = splitSse(done ? `${buffer}\n\n` : buffer);
    buffer = r.rest;
    r.events.forEach(opts.onEvent);
    if (done) return;
  }
}
